// Device fingerprint estável por navegador/dispositivo.
// Combina sinais persistentes (canvas, navegador, fuso) + ID aleatório armazenado.
// Não é à prova de adversário sofisticado, mas eleva o custo de fraude em massa.

const STORAGE_KEY = "zappy.device.fp.v1";

const sha256Hex = async (s: string): Promise<string> => {
  try {
    const buf = new TextEncoder().encode(s);
    const hash = await crypto.subtle.digest("SHA-256", buf);
    return Array.from(new Uint8Array(hash))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch {
    // fallback simples (não criptográfico)
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
    return `fb_${Math.abs(h).toString(16)}`;
  }
};

const canvasSignal = (): string => {
  try {
    const c = document.createElement("canvas");
    c.width = 200; c.height = 50;
    const ctx = c.getContext("2d");
    if (!ctx) return "";
    ctx.textBaseline = "top";
    ctx.font = "14px Arial";
    ctx.fillStyle = "#f60";
    ctx.fillRect(0, 0, 200, 50);
    ctx.fillStyle = "#069";
    ctx.fillText("zappy-fp-🔒", 2, 2);
    return c.toDataURL().slice(-120);
  } catch {
    return "";
  }
};

const collectSignals = (): string => {
  const nav = navigator;
  const screen = window.screen;
  return [
    nav.userAgent,
    nav.language,
    nav.languages?.join(",") || "",
    nav.platform || "",
    nav.hardwareConcurrency || "",
    (nav as any).deviceMemory || "",
    screen.width + "x" + screen.height + "x" + screen.colorDepth,
    new Date().getTimezoneOffset(),
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    canvasSignal(),
  ].join("|");
};

let cached: string | null = null;

export const getDeviceFingerprint = (): string => {
  if (cached) return cached;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored.length >= 16) {
      cached = stored;
      return stored;
    }
  } catch { /* ignore */ }

  // sync seed para uso imediato
  const seed = collectSignals() + "|" + crypto.randomUUID();
  // hash síncrono fallback (FNV-like) só pra ter algo agora
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  const id = `fp_${h.toString(16)}_${Date.now().toString(36)}`;

  try {
    localStorage.setItem(STORAGE_KEY, id);
    // assíncrono: tenta sobrescrever com SHA-256 mais robusto
    sha256Hex(seed).then((digest) => {
      try { localStorage.setItem(STORAGE_KEY, digest); } catch { /* ignore */ }
    });
  } catch { /* ignore */ }

  cached = id;
  return id;
};
